module.exports = __webpack_public_path__ + "img/hand.be5030ca.webp";